import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const LoginCheck = () => {
    const { isAuthenticated } = useAuth0();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { content } = useContentfulContext();

    useEffect(() => {
        if (!content?.EMAIL_VERIFICATION_RESPONSE || !content?.EMAIL_NOT_VERIFIED) return;

        if (searchParams.get("error")) {
            if(content.EMAIL_VERIFICATION_RESPONSE["user is blocked"]?.key === searchParams.get("error_description")) {
                const { search } = location;
                navigate('/auth/blocked-user' + search)
            } else if(content.EMAIL_NOT_VERIFIED["verify_email_before_login"]?.key === JSON.parse(searchParams.get("error_description")).message){
                const { search } = location;
                navigate('/auth/validate-email' + search)
            } else if(content.EMAIL_NOT_VERIFIED["user_registration_successfully"]?.key === JSON.parse(searchParams.get("error_description")).message) {
                const { search } = location;
                navigate('/auth/validate-email' + search)
            }
        }
    }, [searchParams.get("error"), content])

    useEffect(() => {
        if(isAuthenticated) navigate("/dashboard");
    }, [isAuthenticated])
    
    if (isAuthenticated) {
        return <></>;
    }
  return (
   <></>
  )
}

export default LoginCheck